import { Badge } from '@openai/apps-sdk-ui/components/Badge';
import { Button } from '@openai/apps-sdk-ui/components/Button';
import { Loop } from '@openai/apps-sdk-ui/components/Icon';
import type { Recurrence, RecurrenceConfig } from '../shared/types';
import { Field } from './ui';

export type RepeatChoice = RecurrenceConfig['frequency'] | 'off';
export const repeatChoice = (recurrence: Recurrence | null | undefined): RepeatChoice =>
  recurrence?.active ? recurrence.frequency : 'off';
export function RepeatBadge({ recurrence }: { recurrence: Recurrence | null | undefined }) {
  if (!recurrence) return null;
  const label = recurrence.frequency[0].toUpperCase() + recurrence.frequency.slice(1);
  return (
    <Badge color="secondary" className="repeat-badge">
      <Loop />
      {label}
      {!recurrence.active && ' · stopped'}
    </Badge>
  );
}
export function RepeatControls({
  value,
  onChange,
  busy,
  existing,
  active,
  historical,
  apply,
}: {
  value: RepeatChoice;
  onChange: (value: RepeatChoice) => void;
  busy: boolean;
  existing: boolean;
  active: boolean;
  historical: boolean;
  apply?: () => void;
}) {
  return (
    <div className="repeat-controls">
      <Field label="Repeat">
        <select
          name="repeat"
          aria-label="Repeat"
          value={value}
          onChange={(event) => onChange(event.target.value as RepeatChoice)}
          disabled={busy || historical}
        >
          <option value="off">Off</option>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </Field>
      {existing && !historical && (
        <Button
          color="secondary"
          variant="outline"
          size="sm"
          disabled={busy || (value === 'off' && !active)}
          onClick={apply}
        >
          {value === 'off' ? 'Stop future repeats' : 'Apply repeat'}
        </Button>
      )}
      <p>
        {historical
          ? 'Completed repeat occurrences are kept as history.'
          : 'The next occurrence appears when you complete this one. Turning repeat off keeps this occurrence.'}
      </p>
    </div>
  );
}
